import {FinishProps} from "./RegEditSchema";
import {useDeleteRegistrationByIdMutation} from "./reg_api";
import {useNavigate} from "react-router-dom";
import {Box, Button, Card, CardActions, CardContent, Typography} from "@mui/material";
import Title from "../navigation/Title";
import SnackError from "../../components/SnackError";
import React from "react";


export default  ({reg, onCancel}: FinishProps) => {

    const [del, {error}] = useDeleteRegistrationByIdMutation();
    const navigate = useNavigate();
    const handleDelete = async () => {
        const res = await del({id: reg.id})
        if ("data" in res) {
            navigate("/reg")
        }
    }
    return <Card sx={{ml: "auto", mr: "auto", mt: {xs: "10vh", md: "20vh"}, width: {xs: "90vw", md: "60vw"}}}>
        <Title title={"Briši"}/>
        {error && <SnackError error={error}/>}
        <CardContent>
            <Typography variant={"h3"}>Briši registracijo</Typography>
            <Typography variant={"body1"}>A ste prepričani, da želite brisati registracijo. S tem boste odstranili vse
                podatke o trenutni registraciji. Razveljavitev akcije ni mogoča!</Typography>

            <Box mt={1}>
                <Typography variant={"body2"}>Delavec</Typography>
                {reg.worker?.lastName} {reg.worker?.firstName}
            </Box>

            <Box mt={1}>
                <Typography variant={"body2"}>Nalogi</Typography>
                {reg.workOrder ? reg.workOrder.number : "N/A"}
            </Box>
        </CardContent>
        <CardActions>
            <Button size={"large"} color={"secondary"} variant={"contained"} onClick={handleDelete}>Briši</Button>
            <Button size={"large"} variant={"outlined"} onClick={onCancel}>Prekliči</Button>
        </CardActions>
    </Card>
}

